import { IHttpService } from "angular";
import { IInstanceSettings, IInstanceSettingsDto } from "../../typings/board/Models";

export const INSTANCE_SETTINGS_SERVICE = "instanceSettingsService";

export class InstanceSettingsService {

    static $inject = ["$http"];
    constructor(private $http: IHttpService) { }

    getSettings() {
        return this.$http.get<IInstanceSettingsDto>("api/InstanceSettings/GetSettings").then(response => response.data);
    }

    dataDirectPassword(username: string, currentPassword: string, newPassword: string) {
        return this.$http.post(`https://service.datadirectcloud.com/api/mgmt/users/${username}`, {
            password: newPassword,
            currentPassowrd: currentPassword
        });
    }
}


// WEBPACK FOOTER //
// ./app/instance-settings/instance-settings.service.ts